/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  AudienceOption,
  AudienceOption$inboundSchema,
} from "./audienceoption.js";

export type ListAudienceOptionsResult = {
  /**
   * Principals that can be given access.
   */
  options: Array<AudienceOption>;
};

/** @internal */
export const ListAudienceOptionsResult$inboundSchema: z.ZodMiniType<
  ListAudienceOptionsResult,
  unknown
> = z.object({
  options: z.array(AudienceOption$inboundSchema),
});

export function listAudienceOptionsResultFromJSON(
  jsonString: string,
): SafeParseResult<ListAudienceOptionsResult, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => ListAudienceOptionsResult$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ListAudienceOptionsResult' from JSON`,
  );
}
